import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { api } from '../api/client.ts';
import { LionMark } from '../components/LionMark.tsx';

export function Bootstrap() {
  const { token } = useParams<{ token: string }>();
  const nav = useNavigate();
  const [status, setStatus] = useState<'pending' | 'ok' | 'error'>('pending');
  const [err, setErr] = useState<string>('');

  useEffect(() => {
    if (!token) return;
    api('/api/auth/bootstrap-claim', { method: 'POST', json: { token } })
      .then(() => {
        setStatus('ok');
        setTimeout(() => nav('/', { replace: true }), 500);
      })
      .catch((e: unknown) => {
        setStatus('error');
        setErr(e instanceof Error ? e.message : 'failed');
      });
  }, [token, nav]);

  return (
    <Centered>
      <LionMark size={64} />
      <h1 className="lt-serif" style={{ fontSize: 26, fontWeight: 500, margin: '20px 0 6px' }}>
        Claiming this device
      </h1>
      {status === 'pending' && (
        <p style={{ color: 'var(--text-2)' }}>One second…</p>
      )}
      {status === 'ok' && (
        <p style={{ color: 'var(--good)' }}>Done. Taking you home.</p>
      )}
      {status === 'error' && (
        <>
          <p style={{ color: 'var(--danger)' }}>Couldn't claim: {err}</p>
          <p style={{ color: 'var(--text-3)', fontSize: 13, marginTop: 8 }}>
            The token may have been used or expired. Generate a fresh one via the seed script.
          </p>
        </>
      )}
    </Centered>
  );
}

function Centered({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 32,
        textAlign: 'center',
        background: 'var(--bg-app)',
        color: 'var(--text-1)',
      }}
    >
      {children}
    </div>
  );
}
